// The entry snapshot defines option identity, order and labels, including historical dates.
export const getSectionValue = (section, savedItems = [], useDefaults = true) => {
  const options = section.fieldConfig?.options || [];
  if (section.fieldType === "checkbox_list") {
    return {
      items: options.map((option) => ({
        itemId: option.key,
        text: option.label,
        completed: !!savedItems.find((item) => item.itemId === option.key)?.value?.checked,
      })),
    };
  }
  const value = savedItems[0]?.value;
  if (section.fieldType === "bullet_point_list") {
    const bullets = Array.isArray(value)
      ? value
      : useDefaults ? options.map((option) => option.label) : [];
    return { items: bullets.map((text) => ({ text })) };
  }
  if (section.fieldType === "radio_buttons") {
    return { value: options.some((option) => option.key === value) ? value : "" };
  }
  return { value: value ?? "" };
};

export const initializeWorkspace = (schema, entry) =>
  Object.fromEntries((schema?.sections || []).map((section) => [
    section.sectionId,
    getSectionValue(section, entry?.sections?.find((saved) => saved.sectionId === section.sectionId)?.items, !entry),
  ]));

export const buildEntrySections = (schema, workspaceData) =>
  (schema?.sections || []).map((section) => {
    const data = workspaceData[section.sectionId];
    const options = section.fieldConfig?.options || [];
    let items = [];
    if (section.fieldType === "checkbox_list") {
      items = options.map((option) => ({
        itemId: option.key,
        value: {
          label: option.label,
          checked: !!data?.items?.find((item) => item.itemId === option.key)?.completed,
        },
      }));
    } else if (section.fieldType === "bullet_point_list") {
      const value = (data?.items || []).map((item) => item.text?.trim()).filter(Boolean);
      if (value.length) items = [{ itemId: `${section.sectionId}_bullets`, value }];
    } else {
      const value = data?.value;
      const validOption = section.fieldType !== "radio_buttons" || options.some((option) => option.key === value);
      if (validOption && value !== undefined && value !== null && value !== "") {
        items = [{ itemId: `${section.sectionId}_value`, value }];
      }
    }
    return { sectionId: section.sectionId, items };
  });

export const isEntryEditable = (response) =>
  response?.editable === true && ["create", "edit"].includes(response?.mode);
